import {Box, Stack} from '@chakra-ui/react';
import CustomTab from 'components/CustomTab';
import {useAdminPermissionSettings} from 'hooks/datahook/adminPermission';
import {useProfile} from 'hooks/datahook/auth';
import {useAuth} from 'hooks/useAuth';
import {find, get, last, split, trim, trimEnd, trimStart} from 'lodash';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Outlet, useMatches, useNavigate} from 'react-router-dom';
import {adminPaths, paths} from 'routes/path';

const Mt45SettingsLayout = () => {
    const {t} = useTranslation('app');
    const matches = useMatches();
    const matchPath = get(last(matches), 'pathname');
    const navigate = useNavigate();
    const tabs = [
        {
            label: 'MT4',
            value: 'MT4',
            path: adminPaths.mt4Settings,
        },
        {
            label: t('MT4Demo'),
            value: 'MT4Demo',
            path: adminPaths.mt4DemoSettings,
        },
        {
            label: 'MT5',
            value: 'MT5',
            path: adminPaths.mt5Settings,
        },
        {
            label: t('MT5Demo'),
            value: 'MT5Demo',
            path: adminPaths.mt5DemoSettings,
        },
        {
            label: t('mtSettings'),
            value: 'settings',
            path: adminPaths.mtSettings
        },
        {
            label: t('dataRollOver'),
            value: 'dataRollOver',
            path: adminPaths.rollOver
        }
    ];
    const value =
        find(tabs, (o) => o.path === matchPath)?.value || tabs[0]?.value;

    return (
        <Stack spacing={4} width="100%">
            <CustomTab
                tabs={tabs}
                tabOnly
                value={value}
                onChange={(v) => {
                    navigate(find(tabs, (o) => o.value === v)?.path);
                }}
            />
            <Box width={'100%'}>
                <Outlet />
            </Box>
        </Stack>
    );
};

export default Mt45SettingsLayout;
